module.exports = __webpack_public_path__ + "media/images/fanclub/merit-chara-04@3x-b52c0e847527dee9f10bbfa112529632.png";